import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ar from "@/i18n/locales/ar.json";
import en from "@/i18n/locales/en.json";

export const SUPPORTED_LANGUAGES = ["ar", "en"];
export const DEFAULT_LANGUAGE = "ar";

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources: {
      ar: { translation: ar },
      en: { translation: en },
    },
    lng: DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: { escapeValue: false },
    returnObjects: true,
    react: { useSuspense: false },
  });
}

export const htmlLangFor = (lang) => (lang === "en" ? "en" : "es-AR");

export default i18n;
